import React from "react";
import tw from "twin.macro";
import styled, { keyframes, css } from "styled-components";
import logo from "../../images/logo/logo.svg";
import NavToggler from "../../components/features/NavToggler";
import { useTranslation } from "react-i18next";

const HeaderContainer = styled.header`
    ${tw`hidden lg:flex flex-wrap justify-center items-center mx-48  `}
    max-width: 1500px;
    margin-top: 20px;
    padding: 0;
    box-sizing: border-box;
`;


const NavLinks = tw.div`inline-flex flex-wrap gap-x-6 gap-y-2`;

const NavLink = styled.a`
    font-family: 'SFUIText', sans-serif;
    ${tw`text-lg my-2 lg:text-sm font-semibold tracking-wide transition duration-300 pb-1`}
    ${tw`hover:border-primary-500 hover:text-primary-500 focus:text-primary-500`}
    ${css`
        text-decoration: none;
        color: #2D2D2D;

        &:hover, &:focus {
            color: #0ABD19;
            text-decoration: none;
            ${props => (props.hasBorder ? tw`border-b-2 border-transparent` : tw`border-b-0`)};
        }
    `}
`;

const pulsateAnimation = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
`;

const PrimaryLink = styled(NavLink)`
    ${tw`lg:mx-0 px-8 py-3 rounded text-gray-100 hocus:text-gray-200 focus:shadow-outline border-b-0`}
    background-color: #0ABD19;
    border: none;
    transition: background-color 0.3s ease;

    &:not(:hover):not(:focus) {
        animation: ${pulsateAnimation} 1.5s infinite alternate;
    }

    &:hover, &:focus {
        background-color: #0ABD50;
        transform: scale(1.1);
    }
`;

const LogoLink = styled.a`
    ${tw`flex items-center font-black border-b-0 `} /* добавлен mr-4 вместо отступа по умолчанию */
    img { ${tw`w-32 h-10 w-auto h-auto`} } /* немного уменьшено */
`;

const DesktopNavLinks = styled.nav`
    ${tw`hidden lg:flex items-center w-full flex-wrap gap-x-10 gap-y-4`}
`;


export default function HeaderLight({ roundedHeaderButton = false, logoLink, links, className }) {
    const { t } = useTranslation();

    const defaultLinks = [
        <NavLinks key={1}>
            <NavLink href="/PersonalArea">{t("cabinetHeader.links.personal")}</NavLink>
            <NavLink href="/IncomingParcels">{t("cabinetHeader.links.incoming")}</NavLink>
            <NavLink href="/OutgoingParcels">{t("cabinetHeader.links.outgoing")}</NavLink>
            <NavLink href="/DeliveredParcels">{t("cabinetHeader.links.delivered")}</NavLink>
            <NavLink href="/WarehouseServices">{t("cabinetHeader.links.warehouse")}</NavLink>
            <NavLink href="/Purchaseofgoods">{t("cabinetHeader.links.buyout")}</NavLink>
        </NavLinks>
    ];

    const defaultLogoLink = (
        <LogoLink href="/">
            <img src={logo} alt={t("common.logoAlt")} />
        </LogoLink>
    );

    const finalLogo = logoLink || defaultLogoLink;
    const finalLinks = links || defaultLinks;

    return (
        <HeaderContainer className={className || "header-light"}>
            <DesktopNavLinks>
                {finalLogo}
                {finalLinks}
            </DesktopNavLinks>
            <NavToggler />
        </HeaderContainer>

    );
}
